import awsSigV4 from './awsSigV4';

const region = 'us-east-1';
const service = 'auth';

export const applyAwsSigV4Interceptor = (client, accessKey, secretKey) => {
	return client.interceptors.request.use(
		config => {
			const time = Date.now();
			const signingHeaders = {
				...config.headers,
				'X-Amz-Date': awsSigV4.toTime(time)
			};
			Object.keys(signingHeaders).forEach(key => {
				if (typeof signingHeaders[key] !== 'string') {
					delete signingHeaders[key];
				}
			});
			const signedHeaders = awsSigV4.createSignedHeaders(signingHeaders);
			const canonicalRequest = awsSigV4.createCanonicalRequest(config.method, config.baseURL + config.url, '', signingHeaders, '');
			const signedString = awsSigV4.createStringToSign(time, region, service, canonicalRequest);
			const signature = awsSigV4.createSignature(secretKey, time, region, service, signedString);

			config.headers.common['X-Amz-Date'] = signingHeaders['X-Amz-Date'];
			config.headers.common['Authorization'] = awsSigV4.createAuthorizationHeader(
				accessKey,
				`${awsSigV4.toDate(time)}/${region}/${service}/aws4_request`,
				signedHeaders,
				signature
			);

			return config;
		},
		error => Promise.reject(error)
	);
};
